import { render, staticRenderFns } from "./SvgOtherCategory.vue?vue&type=template&id=172dad06&scoped=true"
import script from "./SvgOtherCategory.vue?vue&type=script&lang=js"
export * from "./SvgOtherCategory.vue?vue&type=script&lang=js"
import style0 from "./SvgOtherCategory.vue?vue&type=style&index=0&id=172dad06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172dad06",
  null
  
)

export default component.exports